import React from "react";
import { 
  HeroSection, 
  GlobalStyle, 
  ContentWrapper, 
  LeftContent, 
  ImagesContainer,
  Title,
  TitleLine1,
  TitleLine2,
  Description,
  Buttons,
  StyledButton,
  LargeCircle,
  LargeCircleOverlay,
  ImageCircle,
  SignatureContainer,
  CoinImage,
  Ellipse5Image,
  PolygonImage,
  Ellipse7Image,
  Ellipse4Image
} from "./Hero.styles";
import { PlusIcon, SearchIcon } from "../shared/icons";

// Import des images
import Signature from "../../assets/signature.png";
import Coin from "../../assets/coin.png";
import Polygon from "../../assets/PolygonO.png";
import Eclipse1 from "../../assets/Ellipse4.png";
import Eclipse2 from "../../assets/Ellipse5.png";
import Eclipse3 from "../../assets/Ellipse7.png";

// Import des nouvelles images
import Boy from "../../assets/boy.png";
import Femme from "../../assets/femme1.jpg";
import Jeu from "../../assets/jeu1.png";
import Photographe from "../../assets/photographe1.png";
import Reseau from "../../assets/reseaux1.png";

// Import des composants de formes SVG
import BoyShape from "../../components/BoyShape";
import Photo1Shape from "../../components/Photo1Shape";
import Photo3Shape from "../../components/Photo3Shape";
import Photo4Shape from "../../components/Photo4Shape";
import Photo5Shape from "../../components/Photo5Shape";

const Hero = () => {
  return (
    <>
      <GlobalStyle />
      <HeroSection>
        <ContentWrapper>
          <LeftContent>
            <Title>
              <TitleLine1>La force du numérique</TitleLine1>
              <TitleLine2>L'art de communiquer</TitleLine2>
            </Title>
            <Description>
              De la conception de solutions digitales au<br />
              storytelling visuel : OlaSoft donne vie à vos<br />
              idées digitales et publicitaires.
            </Description>
            <Buttons>
              <StyledButton className="btn-primary">
                <PlusIcon color="#000000" />
                En savoir plus
              </StyledButton>
              <StyledButton className="btn-secondary">
                <SearchIcon color="#ffffff" />
                Rechercher
              </StyledButton>
            </Buttons>
          </LeftContent>

          <ImagesContainer>
            {/* Grand cercle principal - SVG intégré directement */}
            <LargeCircle>
              <svg 
                width="100%" 
                height="100%" 
                viewBox="0 0 937 1207" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid meet"
              >
                <g filter="url(#filter0_f_349_70)">
                  <circle 
                    cx="603.394" 
                    cy="603.394" 
                    r="518.894" 
                    stroke="#FF3D00" 
                    strokeWidth="13"
                  />
                </g>
                <defs>
                  <filter 
                    id="filter0_f_349_70" 
                    x="0" 
                    y="0" 
                    width="1206.79" 
                    height="1206.79" 
                    filterUnits="userSpaceOnUse" 
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="39" result="effect1_foregroundBlur_349_70"/>
                  </filter>
                </defs>
              </svg>
            </LargeCircle>
            <LargeCircleOverlay />
            
            {/* Photo1 - Dame avec forme cercle */}
            <ImageCircle className="photo1">
              <Photo1Shape image={Femme} />
            </ImageCircle>

            {/* Photo2 - Boy avec forme personnalisée */}
            <ImageCircle className="photo2">
              <BoyShape boyImage={Boy} />
            </ImageCircle>

            {/* Photo3 - Réseau avec forme personnalisée */}
            <ImageCircle className="photo3">
              <Photo3Shape image={Reseau} />
            </ImageCircle>

            {/* Photo4 - Jeu avec forme rectangulaire arrondie */}
            <ImageCircle className="photo4">
              <Photo4Shape image={Jeu} />
            </ImageCircle>

            {/* Photo5 - Photographe avec forme personnalisée */}
            <ImageCircle className="photo5">
              <Photo5Shape image={Photographe} />
            </ImageCircle>
          </ImagesContainer>
        </ContentWrapper>

        <SignatureContainer>
          <img src={Signature} alt="Signature" />
        </SignatureContainer>

        {/* Image Coin - en bas de tout */}
        <CoinImage>
          <img src={Coin} alt="Coin decoration" />
        </CoinImage>

        {/* Ellipse5 - au-dessus de tout */}
        <Ellipse5Image>
          <img src={Eclipse2} alt="Ellipse decoration" />
        </Ellipse5Image>

        {/* PolygonO - au-dessus de tout */}
        <PolygonImage>
          <img src={Polygon} alt="Polygon decoration" />
        </PolygonImage>

        {/* Ellipse7 - au-dessus de tout */}
        <Ellipse7Image>
          <img src={Eclipse3} alt="Ellipse decoration" />
        </Ellipse7Image>

        {/* Ellipse4 - au-dessus de tout */}
        <Ellipse4Image>
          <img src={Eclipse1} alt="Ellipse decoration" />
        </Ellipse4Image>
      </HeroSection>
    </>
  );
};

export default Hero;